/* ============
 * Contact
 * ============
 *
 * This is the page for editing contact.
 */
import { mapGetters } from 'vuex';
import Forms from './../../../../utils/forms/forms';
import contactTransformer from './../../../../transformers/contact';
import contactService from './../../../../services/contact';

export default {
  data() {
    return {
      form: new Forms({
        firstName: {
          value: '',
          type: 'text',
        },
        lastName: {
          value: '',
          type: 'text',
        },
        email: {
          value: '',
          type: 'text',
        },
        phoneNumber: {
          value: '',
          type: 'text',
        },
        mobileNumber: {
          value: '',
          type: 'text',
        },
      }),
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      contact: 'contact',
    }),
  },

  watch: {
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} contact    The contact.
     */
    contact(contact) {
      this.form.assignData(contact);
    },
  },

  mounted() {
    const requests = [];
    this.form.assignData(this.contact);

    if (Object.keys(this.contact).length === 0) {
      requests.push(contactService.show());
    }

    this.loading = true;
    Promise.all(requests).then(() => {
      this.loading = false;
    });
  },

  methods: {
    /**
     * This method will be called when saving the form.
     */
    save() {
      this.form.loading = true;
      const contact = contactTransformer.send(this.form.data());
      Promise.resolve(contactService.update(contact))
      .then(() => {
        this.form.loading = false;
        this.form.successMessage = this.$t('static.profileContact.addressSaveSuccess');
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/profile/contact/contact.js